<template>
    <div>
        <PageHeader :title="pageHeader" description="Aqui você vê um resumo inteiro do seu negócio"></PageHeader>
    </div>
</template>

<script>

export default {
    setup() {
        const pageHeader = 'Relatórios';

        return {
            pageHeader
        }
    },
}
</script>